import { Container, Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./NavHeader.css";

const NavHeader = ({ aBout, explorer, Review, Home }) => {
  const scrollTo = (ref) => ref.current.scrollIntoView({ behavior: "smooth" });

  return (
    <Navbar expand="lg" id="header" className="nav-fixed">
      <Container>
        {/* هنا بدل اللوجو نص */}
        <Navbar.Brand className="text-logo fw-bold" style={{ fontSize: "24px" }}>
          Ahmed Restaurant
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <NavLink onClick={() => scrollTo(Home)} className="nav-link">
              Home
            </NavLink>
            <NavLink onClick={() => scrollTo(aBout)} className="nav-link">
              About Us
            </NavLink>
            <NavLink onClick={() => scrollTo(explorer)} className="nav-link">
              Explore Foods
            </NavLink>
            <NavLink onClick={() => scrollTo(Review)} className="nav-link">
              Reviews
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavHeader;


